"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Grid_1 = __importDefault(require("@mui/material/Grid"));
var react_1 = __importDefault(require("react"));
var Main_1 = __importDefault(require("components/Layout/Main"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var HoCs_1 = require("utils/HoCs");
var OnboardingLayout_1 = __importDefault(require("./OnboardingLayout"));
// We have five steps that are static, only the fill in the gaps section has dynamic number of steps to be completed.
var Onboarding = function () { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Hudled - Onboarding", description: "Onboarding - Get started with Hudled!" }), (0, jsx_runtime_1.jsx)(Main_1.default, __assign({ hasSidebar: true }, { children: (0, jsx_runtime_1.jsx)(Grid_1.default, __assign({ container: true, width: 640, mt: 3, pb: 4, mx: "auto" }, { children: (0, jsx_runtime_1.jsx)(OnboardingLayout_1.default, {}) })) }))] })); };
exports.default = react_1.default.memo((0, HoCs_1.HasCompanyHoC)(Onboarding));
